/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 発注業務可能フラグ（金曜日）
 * @export
 * @interface EnableOrderdayFri
 */
export interface EnableOrderdayFri {
}

/**
 * Check if a given object implements the EnableOrderdayFri interface.
 */
export function instanceOfEnableOrderdayFri(value: object): value is EnableOrderdayFri {
    return true;
}

export function EnableOrderdayFriFromJSON(json: any): EnableOrderdayFri {
    return EnableOrderdayFriFromJSONTyped(json, false);
}

export function EnableOrderdayFriFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableOrderdayFri {
    return json;
}

export function EnableOrderdayFriToJSON(json: any): EnableOrderdayFri {
    return EnableOrderdayFriToJSONTyped(json, false);
}

export function EnableOrderdayFriToJSONTyped(value?: EnableOrderdayFri | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

